import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import { Http } from '../../../../support';
import DecimalForConceptos from '../../support/impuestos/DecimalForConceptos';
import ProcessCfdiToJsonInputConversion from '../../transformers/ProcessCfdiToJsonInputConversion';

class UsePrefacturaBaseInputForm extends Component {

  state = {}

  componentDidMount() {
    if (!!this.props.prefactura) {
      this.handleOnChange({
        prefactura: this.props.prefactura
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }


  handleOnChange = (event) => {
    const data = {
      ...this.state.data,
      ...event
    };

    this.setState({
      data
    });

    !!data.prefactura && this.handleOnSearch(data.prefactura)
  }

  handleOnSearch = async (prefactura) => {
    try {
      this.setState({
        busy: true
      });

      const params = {
        include: 'emisor.nomina,emisor.series,receptor.nomina,field'
      }

      const response = await Http.get(`/api/prefacturas/${prefactura}`, { params });

      let input = response.data.field.input;

      input.Emisor = response.data.emisor;
      input.Receptor = response.data.receptor;

      const { comprobante } = this.props;

      const metadata = input.Metadata;

      const data = ProcessCfdiToJsonInputConversion.make(input, comprobante);

      const { Adicional } = metadata;

      data.Observaciones = Adicional?.Observaciones;

      if (!!metadata.Decimales) {
        data.Decimales = metadata.Decimales;

        DecimalForConceptos.decimales = parseInt(metadata.Decimales);
      }

      this.props.onChange(data)
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =('
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    return (
      <>
        <Row>
          <Col className="pt-2">
            <p>
              Revisa la información de tu Prefactura, si todos los datos son correctos hacer clic en "Crear factura".
            </p>

            { this.props.children }
          </Col>
        </Row>
      </>
    )
  }
}

export default UsePrefacturaBaseInputForm;